import { useEffect, useMemo, useState } from "react";
import { CONTINENT } from "@/contants";
import { useCompConfig } from "@/context/CompConfigContext";
import { buildThemeConfig } from "@/components/LichThiDauFull/buildThemeConfig";
import { KbvPluginService } from "@/services/kbvPluginService";

const DEFAULT_CONTINENT = "the-gioi";
const PAGE_SIZE = 20;

export function continentLabel(eng) {
  return CONTINENT.find((c) => c.eng === eng)?.vn || eng || "";
}

export function filterByContinent(rows, continentSlug) {
  const slug = continentSlug || DEFAULT_CONTINENT;
  if (slug === DEFAULT_CONTINENT) return rows;
  const eng = CONTINENT.find((c) => c.slug === slug)?.eng;
  if (!eng) return rows;
  return rows.filter((row) => row.continent === eng);
}

export default function useBangXepHangFifa(type, continentProp) {
  const compConfig = useCompConfig();
  const themeStyle = buildThemeConfig(compConfig, compConfig.hasDataConfig);
  const hasFixedContinent = Boolean(continentProp);

  const [activeContinent, setActiveContinent] = useState(
    continentProp || DEFAULT_CONTINENT,
  );
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [failed, setFailed] = useState(false);
  const [visibleItems, setVisibleItems] = useState(PAGE_SIZE);

  useEffect(() => {
    setActiveContinent(continentProp || DEFAULT_CONTINENT);
  }, [continentProp]);

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    setFailed(false);
    setRows([]);
    setVisibleItems(PAGE_SIZE);

    (async () => {
      const list = await KbvPluginService.getFifaRanking(type);
      if (cancelled) return;
      if (!Array.isArray(list) || list.length === 0) {
        setRows([]);
        setFailed(true);
        setLoading(false);
        return;
      }
      setRows(list);
      setLoading(false);
    })();

    return () => {
      cancelled = true;
    };
  }, [type]);

  useEffect(() => {
    setVisibleItems(PAGE_SIZE);
  }, [activeContinent]);

  const filtered = useMemo(
    () =>
      filterByContinent(rows, activeContinent).sort(
        (a, b) => Number(b.score) - Number(a.score),
      ),
    [rows, activeContinent],
  );

  const visible = useMemo(
    () => filtered.slice(0, visibleItems),
    [filtered, visibleItems],
  );

  const loadMore = () => {
    setVisibleItems((n) => n + PAGE_SIZE);
  };

  return {
    themeStyle,
    hasFixedContinent,
    continents: CONTINENT,
    activeContinent,
    setActiveContinent,
    rows: visible,
    total: filtered.length,
    visibleItems,
    loading,
    failed,
    loadMore,
    canLoadMore: visibleItems < filtered.length,
  };
}
